import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

function BaseIcon({ children, size = 20, ...props }: IconProps) {
  return (
    <svg
      aria-hidden={props["aria-hidden"]}
      fill="none"
      focusable="false"
      height={size}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width={size}
      {...props}
    >
      {children}
    </svg>
  );
}

export function Check(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="m20 6-11 11-5-5" />
    </BaseIcon>
  );
}

export function ChevronRight(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="m9 18 6-6-6-6" />
    </BaseIcon>
  );
}

export function CircleDot(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="1" fill="currentColor" />
    </BaseIcon>
  );
}

export function Clipboard(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M8 4h8" />
      <path d="M9 2h6v4H9z" />
      <path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2" />
    </BaseIcon>
  );
}

export function Play(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M6 4.8v14.4a1 1 0 0 0 1.54.84l11.2-7.2a1 1 0 0 0 0-1.68L7.54 3.96A1 1 0 0 0 6 4.8Z" />
    </BaseIcon>
  );
}

export function RefreshCw(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M21 12a9 9 0 0 1-15.36 6.36L3 15" />
      <path d="M3 21v-6h6" />
      <path d="M3 12A9 9 0 0 1 18.36 5.64L21 9" />
      <path d="M21 3v6h-6" />
    </BaseIcon>
  );
}

export function Share2(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <path d="m8.6 13.5 6.8 4" />
      <path d="m15.4 6.5-6.8 4" />
    </BaseIcon>
  );
}

export function Shield(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
    </BaseIcon>
  );
}

export function Trophy(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M8 21h8" />
      <path d="M12 17v4" />
      <path d="M7 4h10v5a5 5 0 0 1-10 0V4Z" />
      <path d="M5 5H3v3a4 4 0 0 0 4 4" />
      <path d="M19 5h2v3a4 4 0 0 1-4 4" />
    </BaseIcon>
  );
}

export function X(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </BaseIcon>
  );
}
